export default __webpack_public_path__ + "static/Surt-SemiBold-c4b72974ac10fd97e1538ba9eca44ded.woff2";